/* eslint-disable react/button-has-type */
import React, { ReactNode } from 'react';
import { BUTTON_TYPES, BUTTON_SIZES } from './constants';
import { getClassNames } from '../../utils';
import Loader from '../Loader';
import withTheme from '../../hocs/withTheme';
import './Button.css';

type ButtonProps = {
    type?: typeof BUTTON_TYPES[number],
    htmltype?: 'submit' | 'button' | 'reset',
    size?: typeof BUTTON_SIZES[number],
    pressed?: boolean,
    loading?: boolean,
    rounded?: boolean,
    disabled?: boolean,
    children?: ReactNode,
    className?: string,
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

function Button(props: ButtonProps) {
    const {
        type = '', htmltype = 'button', size, pressed = false, rounded = false, children = undefined, loading = false, disabled = false, className = '', onClick = () => {}, ...rest
    } = props;
    const classButton = getClassNames(
        'button',
        className,
        { [`button-${size}`]: size },
        { [`button-${type}`]: type },
        { 'button-loading': loading },
        { 'button-pressed': pressed },
        { 'button-rounded': rounded },
    );

    return (
        <button
            type={htmltype}
            disabled={loading ? true : disabled}
            className={classButton}
            onClick={onClick}
            {...rest}
        >
            {loading ? <Loader negative={type === 'danger'} /> : children}
        </button>
    );
}

export default withTheme(Button);
